const round2 = (n) => Math.round(Number(n) * 100) / 100;

export const calculateWinAmount = (odds, wager) => {
  const o = Number(odds);
  const w = Number(wager);
  if (!Number.isFinite(o) || !Number.isFinite(w) || w <= 0) return 0;
  if (o < 0) return round2((-100 / o) * w);
  return round2((o * w) / 100);
};

export const calculatePayout = (odds, wager) => {
  const w = Number(wager);
  if (!Number.isFinite(w) || w <= 0) return 0;
  return round2(calculateWinAmount(odds, w) + w);
};

export const calculateCashoutMultiplier = (liveOdds) => {
  const lo = Number(liveOdds);
  if (!Number.isFinite(lo) || lo === 0) return null;
  if (lo < 0) {
    const abs = Math.abs(lo);
    return abs / (abs + 100);
  }
  return 1 - lo / (lo + 100);
};

export const calculateCashoutOffer = ({
  originalOdds,
  liveOdds,
  wager,
  payout = null,
  riskFactor = 0.05,
} = {}) => {
  const w = Number(wager);
  if (!Number.isFinite(w) || w <= 0) return null;

  const grossPayout =
    payout != null && Number.isFinite(Number(payout))
      ? Number(payout)
      : calculatePayout(originalOdds, w);

  const multiplier = calculateCashoutMultiplier(liveOdds);
  if (multiplier == null) return null;

  const rf = Number(riskFactor);
  const safeRf = Number.isFinite(rf) && rf >= 0 && rf < 1 ? rf : 0.05;
  const offer = grossPayout * multiplier * (1 - safeRf);

  return round2(Math.max(0, offer));
};

export const formatMoney = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0.00";
  return n.toFixed(2);
};
